<div class="main-block">
  <div class="header">
    <div class="left-div">
      <div class="title">
        <div class="title-text">Notes</div>
      </div>
      <div class="chat-audit-block">
        <div class="chat-block" (click)="getChatHistory()" tooltip="View chat history">
          <img src="assets/images/chat-history.svg" />
          <span class="head-text">Chat History</span>
        </div>
        <div class="chat-block" (click)="getAuditLog()" tooltip="View Audit Log">
          <img src="assets/images/audit-log-blue-icon.svg" />
          <span class="head-text">Audit Log</span>
        </div>
      </div>
    </div>
    <div tooltip="Close" placement="left" class="close-text" (click)="closeNotes()">Close</div>
  </div>

  <div class="content" *ngIf="showData" @fadeIn>
    <div class="summary-block">
      <div class="summary-header">
        <div class="summary-header-left-block">
          <img class="summary-icon" src="assets/images/summary-icon.svg" alt="Summary Icon" />
          <div class="summary-title">Summary</div>
        </div>
        <div class="summary-header-right-block">

          <span *ngIf="!isSummaryEdit" class="action-text edit-text" (click)="onEditSummary()" placement="left"
            tooltip="Edit">
            Edit
          </span>

          <span *ngIf="isSummaryEdit && riskSummary" class="action-text save-text" (click)="onSaveSummary()"
            placement="left" tooltip="Save Changes">
            Save Changes
          </span>

          <span *ngIf="isSummaryEdit && !riskSummary" class="action-text save-text-disabled" placement="left"
            tooltip="Disabled">
            Save Changes
          </span>

          <img class="minimize-icon" *ngIf="riskSummary" (click)="showSummaryContent = !showSummaryContent"
            [src]="summaryMinimizeIcon" alt="Summary Icon" placement="left" tooltip="Minimise" />
        </div>
      </div>
      <div class="summary-content-block" *ngIf="showSummaryContent">
        <p *ngIf="!isSummaryEdit" class="summary-text" placement="bottom">{{ formatNumbersInString(riskSummary) }}</p>
        <textarea class="summary-text-area" *ngIf="isSummaryEdit" name="summaryText" [(ngModel)]="riskSummary" cols="20"
          rows="8" appNohtml></textarea>
        <div *ngIf="isSummaryEdit && !riskSummary" class="error-message">{{ inputRequiredError }}</div>
      </div>
    </div>

    <div class="risk-main-block">
      <div class="risk-header-block">
        <div class="risk-header-left-block">
          <img class="risk-icon" [src]="riskIcon" alt="Risk" />
          <h6 class="risk-title">Risk</h6>
        </div>

        <div class="risk-header-right-block">
          <span *ngIf="!isRisksEdit && risks.length" class="action-text edit-text" (click)="onEditRisks()"
            tooltip="Edit" placement="left">
            Edit
          </span>

          <span *ngIf="isRisksEdit && !isAnyDynamicFormInValid()" class="action-text save-text" (click)="onSaveRisks()"
            tooltip="Save Changes" placement="left">
            Save Changes
          </span>

          <span *ngIf="isRisksEdit && isAnyDynamicFormInValid()" class="action-text save-text-disabled"
            tooltip="Disabled" placement="left">
            Save Changes
          </span>

        </div>
      </div>
      <div class="risk-content-block" appDynamicHeight="risk-content-block" *ngIf="!isRisksEdit">
        <div class="empty-risks" *ngIf="!risks.length" @fadeIn>No Data Available</div>

        <div class="risk-items">
          <div class="risk-item" *ngFor="let risk of risks; let i = index">
            <div class="checkbox-item">
              <div style="padding-top: 5.5px">
                <input placement="bottom" class="form-check-input" type="checkbox"
                  (change)="onRiskChange(risk, $event, i)" [value]="risk.IssueId" [checked]="risk.IsRisk"
                  [id]="'riskCheckbox_' + i" />
              </div>
              <!-- checked -->
              <span class="risk-name">{{ i + 1 }}. {{ risk.RiskStatment || "Dummy Issue" }}</span>
              <img *ngIf="risk.is_updated && isSupervisor" [src]="updatedBtn" class="updated-btn"
                (click)="openUpdateLogs(risk)" alt="Update Logs">
            </div>
            <p class="risk-description">{{ risk.RiskDescription || "Dummy Description" }}</p>
            <table class="read-only-risks-data">
              <tbody>
                <tr>
                  <td class="label-row"><label class="risk-item-label">Severity:</label></td>
                  <td class="">
                    <button class="btn risk-severity-btn rounded-pill" [ngClass]="getSeverityClass(risk.RiskSeverity)">
                      <span class="risk-severity-text">{{ getSeverityText(risk.RiskSeverity) }}</span>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td class="label-row"><label class="risk-item-label">Status:</label></td>
                  <td>
                    <span class="risk-item-value">{{ getStatusText(risk.IssueStatusId) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label-row"><label class="risk-item-label">Impact Area:</label></td>
                  <td>
                    <span class="risk-item-value">{{ getImpactText(risk.ImpactId) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label-row"><label class="risk-item-label">Business Impact:</label></td>
                  <td>
                    <span class="risk-item-value">{{ risk.BusinessImpact }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label-row">
                    <label class="risk-item-label">Revenue Impact:<br />(in Millions)</label>
                  </td>
                  <td>
                    <span class="risk-item-value">{{ formatNumbersInString(risk.RevenueImpact)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label-row">
                    <label class="risk-item-label">Margin Impact:<br />(in Millions)</label>
                  </td>
                  <td>
                    <span class="risk-item-value">{{ formatNumbersInString(risk.MarginImpact)}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label-row"><label class="risk-item-label">Total FTEs:</label></td>
                  <td>
                    <span class="risk-item-value">{{ risk.FTE }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="label-row comments-label-cell">
                    <label class="risk-item-label">Comments:</label>
                    <div class="save-action-container" placement="top" tooltip="Click To Save Changes"
                      *ngIf="isSupervisor && isCommentDirty(i)" (click)="onSaveRisks()">

                      <span class="comments-save-text">
                        Save Changes
                      </span>

                    </div>
                  </td>

                  <td>

                    <ng-container>
                      <textarea rows="8" [name]="'riskCommentsView_' + i" [(ngModel)]="risk.Comments"
                        (ngModelChange)="checkMaxLength(i, 'maxCharComments_', 'riskCommentsBox_', riskParameters.maxComments)"
                        [id]="'riskCommentsBox_' + i" cols="20" (input)="onCommentInput(i)"
                        [attr.maxlength]="riskParameters.maxComments"
                        class="risk-item-value risk-item-input risk-item-textarea"
                        [ngClass]="{ 'unsaved-comment-error': isCommentDirty(i), 'error-border': checkError(i, 'Comments') }"
                        appNohtml></textarea>
                      <div class="max-char-text" [id]="'maxCharCommentsEdit_' + i">{{ riskParameters.maxComments }}
                      </div>
                      <div *ngIf="checkError(i, 'Comments')" class="error-message" @fadeIn>Please enter comment</div>
                    </ng-container>
                  </td>
                </tr>
                <tr>
                  <td class="label-row"><label class="risk-item-label">Reason:</label></td>
                  <td>
                    <select class="risk-severity-input" [(ngModel)]="risk.ReasonId"
                      [ngClass]="{ 'error-border': checkError(i, 'Reason') }"
                      (change)="onReasonChange(risk, i, $event)">
                      <option *ngFor="let reasonEl of reasonsData" [value]="reasonEl.id">{{ reasonEl.reason }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>
        </div>
      </div>

      <div class="risk-content-block" [appDynamicHeight]="getRiskBlock()" *ngIf="isRisksEdit" [formGroup]="risksForm">
        <div class="risk-items" formArrayName="risks">
          <div *ngFor="let riskGroup of risksArray.controls; let i = index" [formGroupName]="i" class="risk-item">
            <div class="checkbox-item">
              <input style="display: none" tooltip="Click to enable" placement="right" class="form-check-input"
                type="checkbox" formControlName="IsRisk" (change)="toggleRisk(i, $event)" />
              <!-- checked -->
              <span class="risk-name">{{ i + 1 }}. {{ riskGroup.value.RiskStatment || "Issue-" +
                riskGroup.value.issue_id }}</span>
            </div>

            <table class="risk-item-edit-table">
              <tbody>
                <tr>
                  <td class="label-row-edit"><label class="risk-item-label" [for]="'RiskDescription_' + i">Risk
                      Description:</label></td>
                  <td>
                    <textarea rows="8"
                      (input)="checkMaxLength(i, 'maxCharDescription_', 'RiskDescription_', riskParameters.maxRiskDescription)"
                      formControlName="RiskDescription" cols="20" class="risk-item-input risk-item-textarea"
                      [ngClass]="{ 'error-border': checkError(i, 'RiskDescription') }" [id]="'RiskDescription_' + i"
                      [attr.maxlength]="riskParameters.maxRiskDescription" appNohtml></textarea>

                    <div class="max-char-text" [id]="'maxCharDescription_' + i">Max. Char {{
                      riskParameters.maxRiskDescription }}</div>
                    <div *ngIf="checkError(i, 'RiskDescription')" class="error-message" @fadeIn>Please enter text</div>

                  </td>
                </tr>
                <tr>
                  <td class="label-row-edit"><label class="risk-item-label"
                      [for]="'Risk_Severity' + riskGroup.value.issue_id">Severity:</label></td>
                  <td>
                    <select formControlName="Risk_Severity" class="risk-severity-input"
                      [ngClass]="{ 'error-border': checkError(i, 'Risk_Severity') }"
                      [id]="'Risk_Severity' + riskGroup.value.issue_id">
                      <option *ngFor="let severityEl of severityData" [value]="severityEl.severity_id">{{
                        severityEl.severity }}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td><label class="risk-item-label" [for]="'Status' + riskGroup.value.issue_id">Status:</label></td>
                  <td>
                    <select formControlName="Status" class="risk-severity-input"
                      [ngClass]="{ 'error-border': checkError(i, 'Status') }"
                      [id]="'Status' + riskGroup.value.issue_id">
                      <option *ngFor="let statusEl of statusData" [value]="statusEl.issue_status_id">{{
                        statusEl.issue_description }}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td><label class="risk-item-label" [for]="'Impact_Area' + riskGroup.value.issue_id">Impact
                      Area:</label></td>
                  <td>
                    <select formControlName="Impact_Area" class="risk-severity-input"
                      [ngClass]="{ 'error-border': checkError(i, 'Impact_Area') }"
                      [id]="'Impact_Area' + riskGroup.value.issue_id">
                      <option *ngFor="let impactAreaEl of impactAreaData" [value]="impactAreaEl.impact_id">{{
                        impactAreaEl.impact }}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td><label class="risk-item-label" [for]="'BusinessImpact_' + i">Business Impact:</label></td>
                  <td>
                    <textarea rows="8"
                      (input)="checkMaxLength(i, 'maxCharBusinessImpact_', 'BusinessImpact_', riskParameters.maxBusinessImpact)"
                      formControlName="Business_Impact" cols="20" class="risk-item-input risk-item-textarea"
                      [attr.maxlength]="riskParameters.maxBusinessImpact"
                      [ngClass]="{ 'error-border': checkError(i, 'Business_Impact') }" [id]="'BusinessImpact_' + i"
                      appNohtml></textarea>

                    <div class="max-char-text" [id]="'maxCharBusinessImpact_' + i">Max. Char {{
                      riskParameters.maxBusinessImpact }}</div>
                    <div *ngIf="checkError(i, 'Business_Impact')" class="error-message" @fadeIn>Please enter text</div>

                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="risk-item-label" [for]="'Revenue_Impact' + riskGroup.value.issue_id">Revenue Impact:
                      <br />(in Millions)</label>
                  </td>
                  <td>
                    <input type="number" (drop)="preventDragDrop($event)" (dragover)="preventDragDrop($event)"
                      (keypress)="allowDigitsWithDecimal($event)" formControlName="Revenue_Impact"
                      class="risk-item-input" [ngClass]="{ 'error-border': checkError(i, 'Revenue_Impact') }"
                      [id]="'Revenue_Impact' + riskGroup.value.issue_id" appNohtml />
                    <div *ngIf="checkError(i, 'Revenue_Impact')" class="error-message" @fadeIn>Please enter positive
                      number</div>

                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="risk-item-label" [for]="'Margin_Impact' + riskGroup.value.issue_id">Margin Impact:
                      <br />(in Millions)</label>
                  </td>
                  <td>
                    <input type="number" (drop)="preventDragDrop($event)" (dragover)="preventDragDrop($event)"
                      (keypress)="allowDigitsWithDecimal($event)" formControlName="Margin_Impact"
                      class="risk-item-input" [ngClass]="{ 'error-border': checkError(i, 'Margin_Impact') }"
                      [id]="'Margin_Impact' + riskGroup.value.issue_id" appNohtml />
                    <div *ngIf="checkError(i, 'Margin_Impact')" class="error-message" @fadeIn>Please enter positive
                      number</div>
                  </td>
                </tr>
                <tr>
                  <td><label class="risk-item-label" [for]="'Total_FTE' + riskGroup.value.issue_id">Total FTEs:</label>
                  </td>
                  <td>
                    <input type="number" (drop)="preventDragDrop($event)" (dragover)="preventDragDrop($event)"
                      (keypress)="allowOnlyDigits($event)" formControlName="Total_FTE" class="risk-item-input"
                      [ngClass]="{ 'error-border': checkError(i, 'Total_FTE') }"
                      [id]="'Total_FTE' + riskGroup.value.issue_id" appNohtml />
                    <div *ngIf="checkError(i, 'Total_FTE')" class="error-message" @fadeIn>Please enter number between 0
                      and 99999.</div>
                  </td>
                </tr>
                <tr>
                  <td><label class="risk-item-label">Comments:</label></td>
                  <td>
                    <textarea rows="8" [id]="'riskCommentsBoxEdit_' + i" [attr.maxlength]="riskParameters.maxComments"
                      (input)="checkMaxLength(i, 'maxCharCommentsEdit_', 'riskCommentsBoxEdit_', riskParameters.maxComments)"
                      cols="20" class="risk-item-input risk-item-textarea" formControlName="Comments"
                      [ngClass]="{ 'error-border': checkError(i, 'Comments') }" appNohtml></textarea>
                    <div class="max-char-text" [id]="'maxCharCommentsEdit_' + i">{{ riskParameters.maxComments }}</div>
                    <div *ngIf="checkError(i, 'Comments')" class="error-message" @fadeIn>Please enter comment</div>
                  </td>
                </tr>
                <tr>
                  <td><label class="risk-item-label">Reason:</label></td>
                  <td>
                    <select class="risk-severity-input" formControlName="Reason"
                      [ngClass]="{ 'error-border': checkError(i, 'Reason') }" (change)="onReasonChangeEdit(i, $event)">
                      <option *ngFor="let reasonEl of reasonsData" [value]="reasonEl.id">{{ reasonEl.reason }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>
        </div>
      </div>

      <div class="submit-block" *ngIf="isSupervisor && !isRisksEdit">
        <span class="submit-info-text" *ngIf="true">To complete click Submit. The risk(s) will be sent to the Risk
          Officer for review</span>
        <button class="submit" [disabled]="isRisksBlankVal()" [ngClass]="{ disabled: isRisksBlankVal() }"
          [tooltip]="getButtonTooltipSv()" (click)="onSupervisorSubmit()">Submit</button>
      </div>

      <div class="risk-officer-submit-block" *ngIf="isRiskOfficer && !isRisksEdit">
        <button class="submit risk-officer-submit" [disabled]="isRisksValid() || isROFormInvalid()"
          [ngClass]="{ disabled: isRisksValid() || isROFormInvalid() }" [tooltip]="getButtonTooltipRo()"
          (click)="openSidebar()">

          {{1> 0 ? 'Review and log into Risk Register':'Update status in DHD FLM'}}
        </button>
        <button class="submit risk-officer-submit"
          [disabled]="(isRisksValid() && isRisksBlankVal()) || isROFormInvalid()"
          [ngClass]="{ disabled: (isRisksValid() && isRisksBlankVal()) || isROFormInvalid() }"
          (click)="onSaveRisks()">Save</button>
      </div>

    </div>
  </div>

</div>


<!-- Sidebar using PrimeNG Drawer -->
<p-drawer [(visible)]="isSidebarVisible" position="right" styleClass="risk-officer-drawer"
  [style]="{width: '50vw', maxWidth: '600px'}">
  <ng-template pTemplate="content">
    <app-risk-officer-confirm-popup [readOnlyRisk]="readOnlyRisk" [riskIcon]="riskIcon" [risks]="risks"
      [selectedFrequencyData]="selectedFrequency" [selectedPflmIdData]="selectedPflmId"
      (closePopup)="isSidebarVisible = false"></app-risk-officer-confirm-popup>
  </ng-template>
</p-drawer>